const LightingMuted = () => {
  return (
    <svg
      className='card__svg'
      width='161'
      height='140'
      viewBox='0 0 161 140'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M160.477 48.9495L160.421 49.5H160.5V83.7247L160.477 83.9495C160.295 85.7387 159.01 87.5877 156.446 89.0689L90.6403 127.081C87.865 128.684 84.196 129.5 80.5 129.5C76.804 129.5 73.135 128.684 70.3597 127.081L4.55393 89.0689C1.98969 87.5877 0.704525 85.7387 0.522832 83.9495L0.5 83.7246V49.5H0.578735L0.522833 48.9495C0.312781 46.8809 1.56253 44.659 4.55393 42.9311L70.3597 4.91904L70.1096 4.48608L70.3597 4.91904C73.135 3.31591 76.804 2.50001 80.5 2.5C84.196 2.49999 87.865 3.31588 90.6403 4.91901L90.8904 4.48605L90.6403 4.91901L156.446 42.9311C159.437 44.659 160.687 46.8809 160.477 48.9495Z'
        fill='url(#paint0_linear_1332_8049)'
        stroke='url(#paint1_linear_1332_8049)'
      />
      <path
        d='M70.5756 4.80927C73.1539 3.2795 76.564 2.50012 80.001 2.50012C83.438 2.50012 86.8481 3.2795 89.4263 4.80927L150.736 41.1864C153.315 42.7167 154.501 44.656 154.501 46.5001C154.501 48.3442 153.315 50.2835 150.736 51.8139L89.4263 88.191C86.8481 89.7207 83.438 90.5001 80.001 90.5001C76.564 90.5001 73.1539 89.7207 70.5756 88.191L9.2659 51.8139C6.68666 50.2835 5.50098 48.3442 5.50098 46.5001C5.50098 44.656 6.68666 42.7167 9.2659 41.1864L70.5756 4.80927Z'
        fill='#020B27'
        stroke='url(#paint2_linear_1332_8049)'
      />
      <path
        d='M63.1774 41.6926L68.6631 44.6118V60.8396L28.1896 57.34L26.4995 51.4694L63.1774 41.6926Z'
        fill='#020B27'
        stroke='url(#paint3_linear_1332_8049)'
        strokeLinejoin='round'
      />
      <path
        d='M138.432 55.0366V37.9634L95.3223 43.8945L95.3222 55.2293L138.432 55.0366Z'
        fill='#020B27'
        stroke='url(#paint4_linear_1332_8049)'
      />
      <path
        d='M68.6254 44.4119C68.5637 44.4571 68.4607 44.509 68.3068 44.5467L29.5075 54.017L29.6261 54.5028L29.5075 54.017C29.1169 54.1124 28.7818 54.286 28.571 54.5574C28.3441 54.8494 28.299 55.2115 28.4386 55.5382C28.6938 56.1357 29.443 56.4273 30.2426 56.3885L103.513 52.8307C104.659 52.7752 105.617 52.3413 106.052 51.655C106.279 51.2968 106.357 50.8689 106.212 50.444C106.071 50.0316 105.744 49.6923 105.299 49.4355L95.9343 44.0261C95.8782 43.9937 95.8467 43.9663 95.8298 43.9483C95.8472 43.9283 95.8807 43.8976 95.941 43.8637C96.0331 43.8119 96.1719 43.7623 96.3602 43.738L120.085 40.682C122.091 40.4235 123.598 39.5604 124.184 38.3959C124.485 37.7984 124.53 37.1358 124.27 36.5003C124.014 35.8762 123.483 35.3268 122.72 34.8862L113.73 29.6931C110.929 28.0754 106.844 27.5284 103.155 28.2353L63.4112 35.85L63.5053 36.3411L63.4112 35.85C62.0082 36.1189 60.9472 36.7937 60.5716 37.71C60.3782 38.1818 60.3818 38.6921 60.6028 39.1712C60.8192 39.6405 61.2267 40.0447 61.7829 40.3659L68.5733 44.2884C68.6291 44.3206 68.6604 44.3482 68.677 44.3661C68.6668 44.3778 68.6505 44.3934 68.6254 44.4119ZM73.9935 2.04955C75.7654 1.02603 78.1192 0.499978 80.5001 0.5C82.881 0.500022 85.2348 1.02612 87.0066 2.04955L157.951 43.03C159.726 44.0551 160.5 45.3288 160.5 46.4999C160.5 47.6711 159.726 48.9448 157.951 49.9699L87.0065 90.9505C85.2346 91.974 82.8808 92.5 80.4999 92.5C78.119 92.5 75.7652 91.9739 73.9934 90.9505L3.04871 49.97C1.2742 48.9449 0.500032 47.6712 0.5 46.5001C0.499968 45.3289 1.27405 44.0552 3.04871 43.0301L73.9935 2.04955Z'
        fill='#020B27'
        stroke='url(#paint5_linear_1332_8049)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1332_8049'
          x1='86.4358'
          y1='94.0481'
          x2='176.656'
          y2='90.2539'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#171431' stopOpacity='0.56' />
          <stop offset='1' stopColor='#A088FF' stopOpacity='0.72' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1332_8049'
          x1='80.5'
          y1='2'
          x2='80.5'
          y2='130'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A088FF' stopOpacity='0.72' />
          <stop offset='1' stopColor='#1F1C34' stopOpacity='0.56' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1332_8049'
          x1='80.001'
          y1='2.00012'
          x2='80.001'
          y2='91.0001'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A088FF' stopOpacity='0.72' />
          <stop offset='1' stopColor='#1F1C34' stopOpacity='0.56' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_1332_8049'
          x1='47.5205'
          y1='41.1588'
          x2='47.5205'
          y2='61.3847'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A088FF' stopOpacity='0.72' />
          <stop offset='1' stopColor='#1F1C34' stopOpacity='0.56' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_1332_8049'
          x1='116.877'
          y1='37.9634'
          x2='116.877'
          y2='55.2293'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A088FF' stopOpacity='0.72' />
          <stop offset='1' stopColor='#1F1C34' stopOpacity='0.56' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_1332_8049'
          x1='80.5'
          y1='0'
          x2='80.5'
          y2='93'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A088FF' stopOpacity='0.72' />
          <stop offset='1' stopColor='#1F1C34' stopOpacity='0.56' />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default LightingMuted;
